import React from 'react';
import Slider from 'rc-slider';

import config from '@config';

const PixelRatio = ({ minutesPixelRatio, setPixelRatio }) => (
  <div className="tvg-pixelratio-selector">
    <button
      onClick={() => {
        setPixelRatio(
          minutesPixelRatio,
          minutesPixelRatio - config.pixelRatio.step,
        );
      }}
    >
      -
    </button>
    <Slider
      onChange={val => {
        setPixelRatio(minutesPixelRatio, val);
      }}
      value={minutesPixelRatio}
      min={config.pixelRatio.min}
      max={config.pixelRatio.max}
      step={config.pixelRatio.step}
    />
    <button
      onClick={() => {
        setPixelRatio(
          minutesPixelRatio,
          minutesPixelRatio + config.pixelRatio.step,
        );
      }}
    >
      +
    </button>
  </div>
);

export default PixelRatio;
